import DynamicPostWidget from './DynamicPostWidget'
import { instance as hooksManager } from './HooksManager'

declare global {
    interface Window {
        DynamicPosts: {
            init: () => void,
            addHook: (instance: JQuery, hook: string, callback: () => void) => void
        }
    }
}

const $ = jQuery

$(document).ready(init)



function init() {
    $('.cc-dynamic-posts').each((_, it) => {
        const instance = $(it)
        DynamicPostWidget.initialize(instance)
    })
}

const DynamicPosts = {
    init: init,
    addHook: hooksManager.addHook
}

window.DynamicPosts = DynamicPosts